
export default {
  methods: {
    copyEmail() {
      const email = "baobah.ufrn@gmail.com";
      navigator.clipboard.writeText(email).then(() => {
        const emailIcon = document.querySelector(".email") as HTMLElement;
        if (emailIcon) {
          emailIcon.classList.add("copied");
          setTimeout(() => {
            emailIcon.classList.remove("copied");
          }, 2000);
        }
      });
    },
  },
};
